import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function UnaffectedBowelCancer() {
    return ReferralCriteria({
        statement: (
            <>
                <p>
                    2019 guidelines recommend that persons with a family history of colorectal cancer placing them in at
                    least moderate risk category would be eligible for referral to tertiary genetics services unless
                    Lynch syndrome has been excluded by testing of affected individuals in the family.
                </p>
                <p>
                    <a
                        href="https://www.bsg.org.uk/wp-content/uploads/2019/12/Guidelines-for-the-management-of-hereditary-colorectal-cancer.full_.pdf?x90351"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        BCG Guidelines for the management of hereditary colorectal cancer
                    </a>
                </p>
            </>
        ),
        criteria: [
            (<>One first diegree relative diagnosed under the age of 50</>),
            (<>Two relatives on the same side of the family diagnosed at any age, of whom the proband is FDR of at least one affected individual</>),
            (<>Three of more FDRs (of each other) diagnosed with CRC at any age, across at least two generations, of whom the proband is an FDR of at least one affected individual</>),
            (<>One first degree relative diagnosed with bowel cancer, plus two first or second degree relatives diagnosed with bowel cancer, edometrial cancer, or urothelial cancer, one of whom is diagnosed under the age of 50 years</>)
        ],
        properties: {
            color: 'violet'
        }
    });
}

export default UnaffectedBowelCancer;
